import { Company } from "../services/config.service";

export class Study {
  id: number | null = null;
  studyUID: string | null = null;
  location: string | null = null;
  description: string | null = null;
  studyDate: Date | null = null;
  status: string | null = null;

  bookId: number | null = null;
  tokenId: number | null = null;
  patientId: number | null = null;
  patientName: string | null = null;
  radiologistName: string | null = null;
}

export namespace Study {
  export function sanitize(s: Study): Study {
    return {
      id: s.id,
      studyUID: s.studyUID,
      location: s.location,
      description: s.description,
      studyDate: (s.studyDate != null) ? (new Date(s.studyDate)) : null,
      bookId: (s.bookId != null) ? +s.bookId : null,
      tokenId: (s.tokenId != null) ? +s.tokenId : null,
      patientId: (s.patientId != null) ? +s.patientId : null,
      patientName: s.patientName,
      radiologistName: s.radiologistName,
      status: s.status
    }
  }

  export function sanitizeAll(sts: Study[]): Study[] {
    return sts.map(s => sanitize(s))
  }

  export function getExample(company: Company): Study {
    return {
      id: 1,
      bookId: 1,
      description: 'Descripción de ejemplo',
      location: '',
      patientId: 1,
      patientName: (company==Company.M3M) ? 'Paciente M3M' : 'Paciente DeBrain',
      studyDate: new Date(),
      studyUID: '1',
      tokenId: 1,
      radiologistName: 'Guillermo Ruiz',
      status: 'READY'
    }
  }
}